module.exports = __webpack_public_path__ + "components/advertise-header/static/c__card--2@2-62400589dc742679e9748800c21af3b2.jpg";